import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LeftNavComponent } from '../left-nav/left-nav.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-main-layout',
  imports: [CommonModule, RouterModule, LeftNavComponent, MatCardModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css'
})
export class MainLayoutComponent {

}
